<template>
  <v-container
    id="about"
    class="pa-0"
    fluid
    tag="section"
  >
    <v-row
      class="ma-0"
      no-gutters
    >
      <v-col
        cols="12"
        md="4"
      >
        <v-img
          class="hidden-sm-and-down"
          height="calc(100vh - 96px - 150px)"
          :src="require('@/assets/sunflower.png')"
        />
      </v-col>

      <v-col
        class="d-block d-md-flex grey lighten-3 pa-6"
        cols="12"
        md="8"
      >
        <v-responsive
          class="mx-auto px-3 px-md-12"
        >
          <h1
            class="mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            About AECS<br>
          </h1>
          <p>
            Hello, I'm Cheryl Forrester. I am a fully qualified, professional counsellor able to work with you
            on a wide range of personal and emotional issues.
          </p>
          <p>
            I have been a counsellor for {{ years }} years, and also have valuable life experience working in other people-oriented roles, including being
            a qualified Social Worker and a qualified nurse.
          </p>
          <p>
            In therapy sessions, I mainly use a Person-Centred approach, but can also incorporate some aspects of Cognitive Behavioural Therapy (CBT)
            and Gestalt therapy into my practice.
          </p>
          <p>
            My aim is to offer a professional counselling service that values and respects individual differences and diversity;
            and to provide a safe, confidential space for you to talk.
          </p>
          <p>
            I provide face-to-face, telephone, and online counselling. Face-to-face counselling is provided in Rhyl, North Wales.
            Telephone and online counselling can be provided to anyone in the UK.
            If you would like to arrange a session, please contact me.
          </p>
          <div class="signature">
            Cheryl Forrester
          </div>
        </v-responsive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'AboutAECS',

    data: () => ({
      years: (new Date()).getFullYear() - 2014,
    }),
  }
</script>

<style lang="sass">
  .signature
    font-family: lindsey-signature, cursive !important
    font-size: 2rem
    font-style: italic
</style>
